<template>
  <div class="create-video-standard-delivery">
    <p class="level-1">投放设置</p>
    <delivery :form="form" :isStandard='true' />

    <optimize-target
      :form="form"
      cardTitle="预估展现量"
      :externalActions="externalActions"
      :top="0"
    />

    <template v-if="form.mode == '控成本投放'">
      <div class="budget">
        <el-form-item prop="budget">
          <p class="level-2">预算</p>
          <el-input
            placeholder="请输入金额"
            v-model="form.budget"
            size="small"
            class="input-with-select"
          >
            <el-select
              v-model="form.budgetType"
              slot="prepend"
              placeholder="请选择"
            >
              <el-option label="日预算" value="日预算"></el-option>
              <el-option label="总预算" value="总预算"></el-option>
            </el-select>
            <span
              slot="suffix"
              style="
                margin-right: 10px;
                color: rgb(153, 153, 153);
                line-height: 32px;
              "
              >元</span
            >
          </el-input>
        </el-form-item>
      </div>

      <div class="bid">
        <p class="level-2">
          出价<el-tooltip
            content="出价指你愿意为每次转化支付目标价格。价格的高低会影响获得的转化次数。如，如果设置的目标价格过低，你可能会错失一部分转化。出价仅作为智能优化投放的成本参考，实际仍按展示付费"
            placement="top"
            effect="light"
          >
            <i class="el-icon-question"></i>
          </el-tooltip>
        </p>

        <el-form-item prop="bid" style="display: inline-block">
          <el-input v-model="form.bid" class="c-input" placeholder="请输入价格">
            <span
              slot="suffix"
              style="margin-right: 10px; color: rgb(153, 153, 153)"
              >元/{{ adviseText }}</span
            >
          </el-input>
        </el-form-item>
        <span class="advise"
          >根据相似店铺投放情况，建议出价
          <b class="advise-price">{{ advisePrice }}</b>
          元/<span>{{ adviseText }}</span>
        </span>
        <div class="tips">
          <el-image
            class="img"
            :src="require(`@/assets/images/simulation/icon_bao.png`)"
            fit="fit"
          ></el-image>
          <span>按展示付费(oCPM)，根据</span>
          <a
            class="link"
            href="https://school.jinritemai.com/doudian/web/article/aHMNDfneBP7r"
            target="_blank"
            rel="noopener noreferrer"
            >成本保障规则</a
          >
          <span>提供保障福利，请谨慎修改出价或定向，以免失去保障资格</span>
        </div>
      </div>
    </template>

    <template v-else>
      <p class="level-2">日预算</p>
      <p class="tip-bid">
        <i class="el-icon-info"></i
        >请设置贴近实际投放的预算，放量投放下无需出价，系统会尽量花光预算
      </p>
      <el-form-item prop="budget" style="display: inline-block; margin-bottom: 0">
        <el-input v-model="form.budget" class="c-input" placeholder="请输入金额">
          <span
            slot="suffix"
            style="margin-right: 10px; color: rgb(153, 153, 153)"
            >元</span
          >
        </el-input>
      </el-form-item>
    </template>

    <div class="dateTime">
      <p class="level-2">投放日期</p>
      <el-radio-group v-model="form.dateType" size="medium">
        <el-radio-button label="从今天起长期投放"></el-radio-button>
        <el-radio-button label="设置开始和结束日期"></el-radio-button>
      </el-radio-group>
      <div class="date" v-show="form.dateType == '设置开始和结束日期'">
        <el-date-picker
          v-model="form.startTime"
          :picker-options="pickerOptions"
          type="date"
          size="small"
          placeholder="请选择日期"
        >
        </el-date-picker>
        —
        <el-date-picker
          v-model="form.endTime"
          :picker-options="pickerOptions"
          type="date"
          size="small"
          placeholder="请选择日期"
        >
        </el-date-picker>
      </div>

      <p class="level-2">投放时段</p>
      <el-radio-group v-model="form.timeIntervalType" size="medium">
        <el-radio-button label="不限"></el-radio-button>
        <el-radio-button label="指定时间段" disabled></el-radio-button>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
import delivery from "../components/delivery.vue";
import OptimizeTarget from "../components/optimizeTarget.vue";
export default {
  components: { delivery, OptimizeTarget },
  props: {
    form: Object,
  },
  data() {
    return {
      externalActions: [
        {
          icon: require("@/assets/images/simulation/icon_cart.svg"),
          name: "商品购买",
          content: "更多人购买商品",
          disabled: false,
        },
        {
          icon: require("@/assets/images/simulation/icon_fans.svg"),
          name: "粉丝提升",
          content: "更多人关注抖音号",
          disabled: false,
        },
        {
          icon: require("@/assets/images/simulation/icon_heart.svg"),
          name: "点赞评论",
          content: "更多人点赞或评论",
          disabled: false,
        },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
    };
  },
  computed: {
    advisePrice() {
      if (this.form.action == "商品购买") return "25.48～47.77";
      else if (this.form.action == "粉丝提升") return "1.47～2.76";
      else if (this.form.action == "点赞评论") return "0.22～0.42";
    },
    adviseText() {
      if (this.form.action == "商品购买") return "下单";
      else if (this.form.action == "粉丝提升") return "关注";
      else if (this.form.action == "点赞评论") return "点击";
    },
  },
};
</script>

<style lang="less" scoped>
.create-video-standard-delivery {
  .level-1 {
    margin-top: 56px;
    line-height: 34px;
    font-weight: 500;
    font-size: 24px;
    color: #111;
  }

  .level-2 {
    margin-top: 28px;
    margin-bottom: 12px;
    line-height: 20px;
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }

  .el-icon-question {
    margin-left: 3px;
    color: #d3d3d3;
    font-size: 16px;
    vertical-align: -1px;
    cursor: pointer;
  }

  ::v-deep  .el-radio-group {
    .el-radio-button__inner {
      padding-left: 15px;
      padding-right: 15px;
      min-width: 100px;
      height: 34px;
      background: #f2f2f2;
      border: 1px solid transparent;
      color: #333;

      // border-radius: 4px;
      &:hover {
        background-color: #eff0fe;
      }
    }

    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      color: #194ce5;
      border: 1px solid #194ce5;
      background-color: #fff;
      box-shadow: none;
    }
  }
  .budget {
    ::v-deep .input-with-select {
      width: 373px;
      .el-input__inner {
        background-color: #f2f2f2;
      }
      .el-input-group__prepend {
        width: 99px;
        color: #333;
        background-color: #fff;
      }
    }
  }

  .bid {
    .advise {
      margin-left: 20px;
      line-height: 32px;
      .advise-price {
        line-height: 19px;
        font-family: OPPOSans-H;
        font-size: 16px;
        color: #1f1f1f;
      }
    }
    .tips {
      margin-top: 8px;
      line-height: 18px;
      font-size: 12px;
      color: #666;
      .img {
        margin-right: 5px;
        vertical-align: top;
      }
      .link {
        margin: 0 4px;
        color: #194ce5;
      }
    }
  }
  ::v-deep .c-input {
    .el-input__inner {
      background-color: #f2f2f2;
    }
  }
  .tip-bid {
    margin-bottom: 10px;
    line-height: 20px;
    font-size: 12px;
    color: #333;
    .el-icon-info {
      margin-right: 5px;
      font-size: 16px;
      color: #969696;
      vertical-align: -1px;
    }
  }
  .dateTime {
    .date {
      display: inline-block;
      margin-left: 50px;
      ::v-deep .el-date-editor {
        width: 138px;
        .el-input__inner {
          background-color: #f2f2f2;
        }
      }
    }
  }
}
</style>